/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum EquipmentType {
  ANESTHESIAMACHINE = '&#39;Anesthesia Machine&#39;',

  ASPIRATOR = '&#39;Aspirator&#39;',

  BIOCHEMISTRYANALYZER = '&#39;Biochemistry Analyzer&#39;',

  CAUTERYMACHINE = '&#39;Cautery machine&#39;',

  COMPRESSIONUNIT = '&#39;Compression Unit&#39;',

  CT = '&#39;CT&#39;',

  DEFIBRILLATOR = '&#39;Defibrillator&#39;',

  DEFIBRILLATORORAED = '&#39;Defibrillator / AED&#39;',

  ECGOREKG = '&#39;ECG / EKG&#39;',

  ELECTROSURGICALUNIT = '&#39;Electrosurgical Unit&#39;',

  FLOWMETER = '&#39;Flow Meter&#39;',

  HEMATOLOGYANALYZERORCELLCOUNTER = '&#39;Hematology Analyzer / Cell counter&#39;',

  HYPOORHYPERTHERMIAUNIT = '&#39;Hypo/Hyperthermia Unit&#39;',

  INCUBATOR = '&#39;Incubator&#39;',

  INFANTRADIANTWARMER = '&#39;Infant radiant warmer&#39;',

  INFUSIONPUMP = '&#39;Infusion Pump&#39;',

  MOBILEXRAYUNIT = '&#39;Mobile X -ray unit&#39;',

  MRIMACHINE = '&#39;MRI Machine&#39;',

  NEONATALDEVICE = '&#39;Neonatal Device&#39;',

  OXYGENREGULATOR = '&#39;Oxygen regulator&#39;',

  PACEMAKER = '&#39;Pacemaker&#39;',

  PATIENTMONITOR = '&#39;Patient Monitor&#39;',

  PNEUMATICTOURNIQUET = '&#39;Pneumatic Tourniquet&#39;',

  RADIANTWARMER = '&#39;Radiant Warmer&#39;',

  SPHYGMOMANOMETER = '&#39;Sphygmomanometer&#39;',

  STERILIZERORAUTOCLAVE = '&#39;Sterilizer / Autoclave&#39;',

  SUCTIONDEVICE = '&#39;Suction Device&#39;',

  SURGICALLIGHTSOROTLIGHT = '&#39;Surgical lights / OT Light&#39;',

  SURGICALTABLESOROTTABLES = '&#39;Surgical tables/ OT tables&#39;',

  SYRINGEPUMP = '&#39;Syringe Pump&#39;',

  THERAPEUTICSTIMULATOR = '&#39;Therapeutic Stimulator&#39;',

  ULTRASOUND = '&#39;Ultrasound&#39;',

  VENTILATOR = '&#39;Ventilator&#39;',

  XRAYMACHIN = '&#39;X-Ray Machine&#39;',

  DENTALSTATION = '&#39;Dental Station&#39;',
}
